// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QvUK","content":"styles_content__1BQz0"};